export default "__VITE_ASSET__CXu0VkYo__"